export default "__VITE_ASSET__BNYXC6lN__"